module.exports = __webpack_public_path__ + "static/img/63-1.a192aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/63-1.jpg
// module id = 5h8A
// module chunks = 0